export const isClientSide = (): boolean => typeof window !== 'undefined';
